import { Cell, Grid, HFlow, Icon, Text, VFlow } from 'bold-ui'
import { InfoIcon } from 'components/InfoIcon'
import { Color } from 'csstype'
import { formatDate } from 'util/date/formatDate'
import { ListagemGestantePuerperaAtendimentosModel } from 'view/acompanhamento/acompanhamento-condicao-saude/model/lista-tematica/model-gestantePuerpera'

export interface AcompanhamentoCondicaoSaudeGestantePuerperaConsultasPuerperioSectionProps {
  atendimentosPreNatalPuerperio: ListagemGestantePuerperaAtendimentosModel
  dataUltimaConsultaPuerperio: LocalDate
  iconColor?: Color
}

const ACOMPANHAMENTO_PUERPERIO_TOOLTIP_TEXT = 'Apenas consultas realizadas durante o período de puerpério atual'

export function AcompanhamentoCondicaoSaudeGestantePuerperaConsultasPuerperioSection({
  atendimentosPreNatalPuerperio,
  dataUltimaConsultaPuerperio,
  iconColor,
}: Readonly<AcompanhamentoCondicaoSaudeGestantePuerperaConsultasPuerperioSectionProps>) {
  return (
    <Grid gap={1} gapVertical={0.5} alignItems='baseline'>
      <Cell size={12}>
        <HFlow hSpacing={0.25} alignItems='center'>
          <Icon width='1rem' icon='nurse' color={iconColor} />
          <Text fontWeight='bold'>Acompanhamento de puerpério</Text>
          <InfoIcon icon='infoCircleFilled' text={ACOMPANHAMENTO_PUERPERIO_TOOLTIP_TEXT} />
        </HFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>Consultas</Text>
          <Text>{atendimentosPreNatalPuerperio?.consultasPuerperio ?? 0}</Text>
        </VFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>Última consulta</Text>
          <Text>{formatDate(dataUltimaConsultaPuerperio)}</Text>
        </VFlow>
      </Cell>
    </Grid>
  )
}
